<!-- eslint-disable vue/no-mutating-props -->
<template>
  <modal
    :show="show"
    :on-close="closeModal"
    @update:show="$emit('update:show', $event)"
  >
    <otello-modal-header :header-title="title" :header-content="message" />
    <form @submit.prevent="onConfirm">
      <otello-input
        v-model="value"
        type="text"
        :class="{ error: $v.value.$error }"
        :placeholder="confirmPlaceHolderText"
        @blur="$v.value.$touch"
      />
      <div class="button-wrapper">
        <otello-button color-scheme="alert" :is-disabled="$v.value.$invalid">
          {{ confirmText }}
        </otello-button>
        <otello-button class="clear" @click.prevent="closeModal">
          {{ rejectText }}
        </otello-button>
      </div>
    </form>
  </modal>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import Modal from '../../Modal.vue';

export default {
  components: {
    Modal,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: '',
    },
    rejectText: {
      type: String,
      default: '',
    },
    confirmValue: {
      type: String,
      default: '',
    },
    confirmPlaceHolderText: {
      type: String,
      default: '',
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      value: '',
    };
  },
  validations: {
    value: {
      required,
      isEqual(value) {
        return value === this.confirmValue;
      },
    },
  },
  methods: {
    closeModal() {
      this.value = '';
      this.$emit('on-close');
    },
    onConfirm() {
      this.$emit('on-confirm');
    },
  },
};
</script>
